import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import { Calendar, CheckCircle2, ShieldCheck, ArrowRight, UserPlus, LogIn } from 'lucide-react';
import './AdCheckoutPage.css';

export default function AdCheckoutPage() {
  const location = useLocation();
  const navigate = useNavigate();

  // Retrieve plan details passed from Advertising Hub (or default fallback)
  const passedPlan = location.state || {};
  const planName = passedPlan.planName || 'Growth';
  const price = passedPlan.price || '₹999';
  const duration = passedPlan.duration || '1 Month';

  // Calculate today's date in YYYY-MM-DD for min date restriction
  const today = new Date();
  const todayStr = today.toISOString().split('T')[0];

  const [startDate, setStartDate] = useState('');
  const [validationError, setValidationError] = useState('');

  // Format YYYY-MM-DD date to DD-MM-YYYY for display
  const formatDateDisplay = (dateString) => {
    if (!dateString) return '';
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };

  const handleDateChange = (e) => {
    const selected = e.target.value;
    if (selected && selected < todayStr) {
      setValidationError('Past dates are not allowed. Please select today or a future date.');
      setStartDate('');
    } else {
      setValidationError('');
      setStartDate(selected);
    }
  };

  const handleSubscribe = () => {
    if (!startDate) {
      setValidationError('Please select a valid start date before subscribing.');
      return;
    }
    setValidationError('');
    // Static navigation to Dashboard -> Grow Plan
    navigate('/growplan');
  };

  return (
    <div className="ad-checkout-wrapper">
      <Navbar />

      <main className="checkout-main-section">
        <div className="container">

          {/* Header Title */}
          <div className="checkout-header text-center">
            <span className="checkout-badge">Haatza Seller Subscription</span>
            <h1 className="checkout-title">Complete Your Plan Selection</h1>
            <p className="checkout-subtitle">
              Review your selected subscription plan details and choose your start date to get started.
            </p>
          </div>

          <div className="checkout-grid">

            {/* LEFT SECTION: NAVIGATION BUTTONS */}
            <div className="checkout-left-card">
              <div className="card-header-icon">
                <ShieldCheck size={28} className="text-blue-600" />
              </div>
              <h2 className="left-card-heading">Account & Access</h2>
              <p className="left-card-desc">
                Choose an action below to proceed with your seller account or sign in to your dashboard.
              </p>

              <div className="left-buttons-group">
                <button
                  className="checkout-nav-btn btn-signup"
                  onClick={() => navigate('/signup')}
                >
                  <UserPlus size={18} />
                  <span>Sign Up</span>
                </button>

                <button
                  className="checkout-nav-btn btn-login"
                  onClick={() => navigate('/signin')}
                >
                  <LogIn size={18} />
                  <span>Log In</span>
                </button>
              </div>


            </div>

            {/* RIGHT SECTION: SUBSCRIPTION SUMMARY CARD */}
            <div className="checkout-right-card">
              <div className="summary-header">
                <h2 className="summary-title">Subscription Summary</h2>
                <span className="summary-status-pill">Selected Plan</span>
              </div>

              {/* Selected Plan Details */}
              <div className="plan-summary-box">
                <div className="summary-row">
                  <span className="summary-label">Plan Name:</span>
                  <span className="summary-value plan-tag">{planName}</span>
                </div>
                <div className="summary-row">
                  <span className="summary-label">Price:</span>
                  <span className="summary-value price-text">{price}</span>
                </div>
                <div className="summary-row">
                  <span className="summary-label">Duration:</span>
                  <span className="summary-value">{duration}</span>
                </div>
              </div>

              {/* Start Date Picker Section */}
              <div className="date-picker-container">
                <label htmlFor="start-date-input" className="date-picker-label">
                  <Calendar size={18} className="text-blue-600" />
                  <span>Select Subscription Start Date:</span>
                </label>

                <input
                  type="date"
                  id="start-date-input"
                  className="date-input-field"
                  min={todayStr}
                  value={startDate}
                  onChange={handleDateChange}
                />



                {startDate && (
                  <div className="selected-date-preview">
                    <span>Selected Start Date:</span>
                    <strong>{formatDateDisplay(startDate)}</strong>
                  </div>
                )}
              </div>

              {/* Validation Message */}
              {validationError && (
                <div className="checkout-error-box">
                  <span>{validationError}</span>
                </div>
              )}

              {/* Primary Subscribe Button */}
              <button
                className="checkout-subscribe-btn"
                onClick={handleSubscribe}
              >
                <span>Subscribe</span>
                <ArrowRight size={18} />
              </button>

            </div>

          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
}
